import axios from "axios";
import { API_ENDPOINTS, API_URL, SUPER_ADMIN_API_ENDPOINTS, SUPER_ADMIN_API_URL } from "../../constants";
import axiosInstance from "../../core/apiService/webApiService";
import superAdminAxiosInstance from "../../core/apiService/superAdminApiService";

//api call to fetch users list with search
const fetchNonMembersListData = async (
  {
    searchquery,
    pageNumber,
    alphabet,
    groupId,
    hospitalId,
    isActive,
    specialityId,
  }: {
    searchquery: string;
    pageNumber: number;
    alphabet?: string;
    groupId?: string;
    hospitalId?: string;
    isActive?: boolean;
    specialityId?: string;
  },
  token: string
): Promise<any> => {
  const config = {
    headers: {
      Authorization: `Token ${token}`,
    },
  };

  const response = await superAdminAxiosInstance.get(
    `${SUPER_ADMIN_API_URL}${SUPER_ADMIN_API_ENDPOINTS.MEMBER_LISTS.FETCH_NON_MEMBERS}?search=${searchquery}&UserType=non_member`,
    config
  )

  return response.data;
};

const fetchMembersListData = async (
  {
    searchquery,
    pageNumber,
    alphabet,
    groupId,
    hospitalId,
    isActive,
    specialityId,
  }: {
    searchquery: string;
    pageNumber: number;
    alphabet?: string;
    groupId?: string;
    hospitalId?: string;
    isActive?: boolean;
    specialityId?: string;
  },
  token: string
): Promise<any> => {

  const config = {
    headers: {
      Authorization: `Token ${token}`,
    },
  };

  const response = await superAdminAxiosInstance.get(
    `${SUPER_ADMIN_API_URL}${SUPER_ADMIN_API_ENDPOINTS.MEMBER_LISTS.FETCH_MEMBERS}?search=${searchquery}&UserType=member`,
    config
  )
  return response.data;
};

const validateLogin = async (
  {
    username,
    password,
  }: {
    username: string;
    password: string;
  },
  token: string
): Promise<any> => {
  const config = {
    headers: {
      Authorization: `Token ${token}`,
    },
  };

  const response = await superAdminAxiosInstance.post(
    `${SUPER_ADMIN_API_URL}${SUPER_ADMIN_API_ENDPOINTS.MEMBERSHIP_MANAGEMENT.BA_VALIDATION}`,
    { username, password }, // ✅ Body goes here
    config                  // ✅ Headers go here
  );

  return response.data;
};


const makePayment = async (
  {
    amount,
    currency,
    product_name,
    network_details,
    plan_id
  }: {
    amount: string;
    currency: string;
    product_name: any;
    network_details?: any;
    plan_id: number;
  },
  token: string
): Promise<any> => {
  const config = {
    headers: {
      Authorization: `Token ${token}`,
    },
  };

  const response = await superAdminAxiosInstance.post(
    `${SUPER_ADMIN_API_URL}${SUPER_ADMIN_API_ENDPOINTS.MEMBERSHIP_MANAGEMENT.MAKE_PAYMENT}`,
    { amount, currency, product_name, network_details, plan_id }, // ✅ Body goes here
    config                  // ✅ Headers go here
  );

  return response.data;
};


const fetchLocations = async (
  {
    searchquery,
    pageNumber,
    alphabet,
    groupId,
    hospitalId,
    isActive,
    specialityId,
  }: {
    searchquery: string;
    pageNumber: number;
    alphabet?: string;
    groupId?: string;
    hospitalId?: string;
    isActive?: boolean;
    specialityId?: string;
  },
  token: string
): Promise<any> => {

  const config = {
    headers: {
      Authorization: `Token ${token}`,
    },
  };

  const response = await superAdminAxiosInstance.get(
    `${SUPER_ADMIN_API_URL}${SUPER_ADMIN_API_ENDPOINTS.MEMBER_LISTS.FILTER_LOCATION}`,
    config
  )
  return response.data;
};

const fetchSites = async (
  {
    searchquery,
    pageNumber,
    alphabet,
    groupId,
    hospitalId,
    isActive,
    specialityId,
  }: {
    searchquery: string;
    pageNumber: number;
    alphabet?: string;
    groupId?: string;
    hospitalId?: string;
    isActive?: boolean;
    specialityId?: string;
  },
  token: string
): Promise<any> => {

  const config = {
    headers: {
      Authorization: `Token ${token}`,
    },
  };

  const response = await superAdminAxiosInstance.get(
    `${SUPER_ADMIN_API_URL}${SUPER_ADMIN_API_ENDPOINTS.MEMBER_LISTS.FILTER_SITES}`,
    config
  )
  console.log(response, "responseresponse")
  return response.data;
};


const fetchDeletedMembersListData = async (
  {
    searchquery,
    pageNumber,
    alphabet,
    groupId,
    hospitalId,
    isActive,
    specialityId,
  }: {
    searchquery: string;
    pageNumber: number;
    alphabet?: string;
    groupId?: string;
    hospitalId?: string;
    isActive?: boolean;
    specialityId?: string;
  },
  token: string
): Promise<any> => {
  const config = {
    headers: {
      Authorization: `Token ${token}`,
    },
  };

  const response = await superAdminAxiosInstance.get(
    `${SUPER_ADMIN_API_URL}${SUPER_ADMIN_API_ENDPOINTS.MEMBER_LISTS.FETCH_MEMBERS}?search=${searchquery}&IsDeleted=true`,
    config
  )
  return response.data;
};

const filterMembers = async (userPayload: any, token: string): Promise<any> => {
  const config = {
    headers: {
      Authorization: `Token ${token}`,
    },
  };
  const response = await superAdminAxiosInstance.post(`${SUPER_ADMIN_API_URL}${SUPER_ADMIN_API_ENDPOINTS.MEMBER_LISTS.FILTER_MEMBERS}`, userPayload, config);
  return response.data;
};


const deactivateMembers = async (userPayload: any, token: string): Promise<any> => {
  const config = {
    headers: {
      Authorization: `Token ${token}`,
    },
  };
  const response = await superAdminAxiosInstance.post(`${SUPER_ADMIN_API_URL}${SUPER_ADMIN_API_ENDPOINTS.MEMBERSHIP_MANAGEMENT.DEACTIVATE_NETWORKS}`, userPayload, config);
  return response.data;
};

const saveNotes = async (payload: any, token: string): Promise<any> => {
  const config = {
    headers: {
      Authorization: `Token ${token}`,
    },
  };
  const response = await superAdminAxiosInstance.post(`${SUPER_ADMIN_API_URL}${API_ENDPOINTS.USERS.NOTES_CRUD}`, payload, config);
  return response.data;
};


const editNotes = async (userPayload: any, token: string): Promise<any> => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`, // backend expects Bearer
    },
  };

  const response = await superAdminAxiosInstance.put(
    `${SUPER_ADMIN_API_URL}${API_ENDPOINTS.USERS.NOTES_CRUD}?id=${userPayload.id}`,
    { note: userPayload.note }, // <-- THIS is the correct body
    config
  );

  return response.data;
};


const deleteNotes = async (payload: any, token: string): Promise<any> => {

  const config = {
    headers: {
      Authorization: `Token ${token}`,
    },
  };

  const response = await superAdminAxiosInstance.delete(`${SUPER_ADMIN_API_URL}${API_ENDPOINTS.USERS.NOTES_CRUD}?id=${payload.id}`, payload);
  return response.data;


  return response.data;
};

const fetchNotesListData = async (
  {
    id
  }: {
    id: string;
  },
  token: string
): Promise<any> => {
  const config = {
    headers: {
      Authorization: `Token ${token}`,
    },
  };

  const response = await superAdminAxiosInstance.get(
    `${SUPER_ADMIN_API_URL}${API_ENDPOINTS.USERS.NOTES_CRUD}?user_id=${id}`,
    config
  );
  console.log(response, "ressppp")
  return response.data;
};


const updateBusinessAccountDetails = async (userPayload: any, token: string): Promise<any> => {
  const config = {
    headers: {
      Authorization: `Token ${token}`,
    },
  };
  const response = await superAdminAxiosInstance.put(`${SUPER_ADMIN_API_URL}${SUPER_ADMIN_API_ENDPOINTS.MEMBERSHIP_MANAGEMENT.FETCH_BUSINESS_ACCOUNTS}`, userPayload, config);
  return response.data;
};


const activateMembers = async (userPayload: any, token: string): Promise<any> => {
  const config = {
    headers: {
      Authorization: `Token ${token}`,
    },
  };
  const response = await superAdminAxiosInstance.post(`${SUPER_ADMIN_API_URL}${SUPER_ADMIN_API_ENDPOINTS.MEMBERSHIP_MANAGEMENT.ACTIVATE_NETWORKS}`, userPayload, config);
  return response.data;
};

const deleteMembers = async (payload: any, token: string): Promise<any> => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  const response = await superAdminAxiosInstance.delete(
    `${SUPER_ADMIN_API_URL}${SUPER_ADMIN_API_ENDPOINTS.MEMBER_LISTS.FETCH_MEMBERS}`, { ...config, data: payload }
  );
  return response.data;
};


const deleteBusinessAccount = async (payload: any, token: string): Promise<any> => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  const response = await superAdminAxiosInstance.delete(
    `${SUPER_ADMIN_API_URL}${SUPER_ADMIN_API_ENDPOINTS.MEMBERSHIP_MANAGEMENT.FETCH_BUSINESS_ACCOUNTS}`, { ...config, data: payload }
  );
  return response.data;
};

// const deactivateMembers = async (payload: any, token: string): Promise<any> => {
//   const config = {
//     headers: {
//       Authorization: `Bearer ${token}`,
//     },
//   };
//   const response = await superAdminAxiosInstance.post(
//     `${SUPER_ADMIN_API_URL}${SUPER_ADMIN_API_ENDPOINTS.MEMBERSHIP_MANAGEMENT.DEACTIVATE_NETWORKS}`, { ...config, data: payload }
//   );
//   return response.data;
// };


const fetchDynamicNetworksList = async (
  {
    searchquery,
    pageNumber,
    alphabet,
    groupId,
    hospitalId,
    isActive,
    specialityId,
  }: {
    searchquery: string;
    pageNumber: number;
    alphabet?: string;
    groupId?: string;
    hospitalId?: string;
    isActive?: boolean;
    specialityId?: string;
  },
  token: string
): Promise<any> => {
  const config = {
    headers: {
      Authorization: `Token ${token}`,
    },
  };
  const response = await superAdminAxiosInstance.get(
    `${SUPER_ADMIN_API_URL}${SUPER_ADMIN_API_ENDPOINTS.MEMBERSHIP_MANAGEMENT.DN_NW_LISTING}?search=${searchquery}`,
    config
  )

  return response.data;
};

const fetchSAPDynamicNetworksList = async (
  {
    searchquery,
    pageNumber,
    alphabet,
    groupId,
    hospitalId,
    isActive,
    specialityId,
  }: {
    searchquery: string;
    pageNumber: number;
    alphabet?: string;
    groupId?: string;
    hospitalId?: string;
    isActive?: boolean;
    specialityId?: string;
  },
  token: string
): Promise<any> => {
  const config = {
    headers: {
      Authorization: `Token ${token}`,
    },
  };
  const response = await superAdminAxiosInstance.get(
    `${SUPER_ADMIN_API_URL}${SUPER_ADMIN_API_ENDPOINTS.MEMBERSHIP_MANAGEMENT.FETCH_SAP_NETWORKS}?search=${searchquery}&is_active=true`,
    config
  )

  return response.data;
};

const fetchSAPDeactivatedNetworksList = async (
  {
    searchquery,
    pageNumber,
    alphabet,
    groupId,
    hospitalId,
    isActive,
    specialityId,
  }: {
    searchquery: string;
    pageNumber: number;
    alphabet?: string;
    groupId?: string;
    hospitalId?: string;
    isActive?: boolean;
    specialityId?: string;
  },
  token: string
): Promise<any> => {
  const config = {
    headers: {
      Authorization: `Token ${token}`,
    },
  };
  const response = await superAdminAxiosInstance.get(
    `${SUPER_ADMIN_API_URL}${SUPER_ADMIN_API_ENDPOINTS.MEMBERSHIP_MANAGEMENT.FETCH_SAP_DEACTIVATE_NETWORKS}&search=${searchquery}`,
    config
  )
  console.log(response.data, "response")
  return response.data;
};

const fetchSystemMetricsList = async (
  {
    searchquery,
    pageNumber,
    alphabet,
    groupId,
    hospitalId,
    isActive,
    specialityId,
  }: {
    searchquery: string;
    pageNumber: number;
    alphabet?: string;
    groupId?: string;
    hospitalId?: string;
    isActive?: boolean;
    specialityId?: string;
  },
  token: string
): Promise<any> => {
  const config = {
    headers: {
      Authorization: `Token ${token}`,
    },
  };
  const response = await superAdminAxiosInstance.get(
    `${SUPER_ADMIN_API_URL}${SUPER_ADMIN_API_ENDPOINTS.MEMBERSHIP_MANAGEMENT.FETCH_SYSTEM_METRICS}`,
    config
  )

  return response.data;
};

const fetchDBMetricsList = async (
  {
    searchquery,
    pageNumber,
    alphabet,
    groupId,
    hospitalId,
    isActive,
    specialityId,
  }: {
    searchquery: string;
    pageNumber: number;
    alphabet?: string;
    groupId?: string;
    hospitalId?: string;
    isActive?: boolean;
    specialityId?: string;
  },
  token: string
): Promise<any> => {
  const config = {
    headers: {
      Authorization: `Token ${token}`,
    },
  };
  const response = await superAdminAxiosInstance.get(
    `${SUPER_ADMIN_API_URL}${SUPER_ADMIN_API_ENDPOINTS.MEMBERSHIP_MANAGEMENT.FETCH_DB_SIZE}?db_name=${searchquery}`,
    config
  )

  return response.data;
};


const fetchDeactivatedNetworksList = async (
  {
    searchquery,
    pageNumber,
    alphabet,
    groupId,
    hospitalId,
    isActive,
    specialityId,
  }: {
    searchquery: string;
    pageNumber: number;
    alphabet?: string;
    groupId?: string;
    hospitalId?: string;
    isActive?: boolean;
    specialityId?: string;
  },
  token: string
): Promise<any> => {
  const config = {
    headers: {
      Authorization: `Token ${token}`,
    },
  };
  const response = await superAdminAxiosInstance.get(
    `${SUPER_ADMIN_API_URL}${SUPER_ADMIN_API_ENDPOINTS.MEMBERSHIP_MANAGEMENT.FETCH_DEACTIVATE_NETWORKS}?search=${searchquery}`,
    config
  )

  return response.data;
};

const fetchViewNetworksList = async (
  {
    searchquery,
    pageNumber,
    alphabet,
    groupId,
    hospitalId,
    isActive,
    specialityId,
  }: {
    searchquery: string;
    pageNumber: number;
    alphabet?: string;
    groupId?: string;
    hospitalId?: string;
    isActive?: boolean;
    specialityId?: string;
  },
  token: string
): Promise<any> => {
  const config = {
    headers: {
      Authorization: `Token ${token}`,
    },
  };
  const response = await superAdminAxiosInstance.get(
    `${SUPER_ADMIN_API_URL}${SUPER_ADMIN_API_ENDPOINTS.MEMBERSHIP_MANAGEMENT.FETCH_VIEW_NETWORK_LISTS}?user_id=${searchquery}`,
    config
  )

  return response.data;
};


const fetchBusinessAccountList = async (
  {
    searchquery,
    pageNumber,
    alphabet,
    groupId,
    hospitalId,
    isActive,
    specialityId,
  }: {
    searchquery: string;
    pageNumber: number;
    alphabet?: string;
    groupId?: string;
    hospitalId?: string;
    isActive?: boolean;
    specialityId?: string;
  },
  token: string
): Promise<any> => {
  const config = {
    headers: {
      Authorization: `Token ${token}`,
    },
  };
  const response = await superAdminAxiosInstance.get(
    `${SUPER_ADMIN_API_URL}${SUPER_ADMIN_API_ENDPOINTS.MEMBERSHIP_MANAGEMENT.FETCH_BUSINESS_ACCOUNTS}?search=${searchquery}`,
    config
  )

  return response.data;
};

const updateBusinessAccountList = async (payload: any, token: string): Promise<any> => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  const response = await superAdminAxiosInstance.put(
    `${SUPER_ADMIN_API_URL}${SUPER_ADMIN_API_ENDPOINTS.MEMBERSHIP_MANAGEMENT.FETCH_BUSINESS_ACCOUNTS}`,
    payload?.payload,
  );
  return response.data;
};

const deleteBusinessAccountList = async (payload: any, token: string): Promise<any> => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  const response = await superAdminAxiosInstance.delete(
    `${SUPER_ADMIN_API_URL}${SUPER_ADMIN_API_ENDPOINTS.MEMBERSHIP_MANAGEMENT.FETCH_BUSINESS_ACCOUNTS}`, { ...config, data: payload }
  );
  return response.data;
};

const fetchViewDynamicNetworksList = async (
  {
    searchquery,
    pageNumber,
    alphabet,
    groupId,
    hospitalId,
    isActive,
    specialityId,
  }: {
    searchquery: string;
    pageNumber: number;
    alphabet?: string;
    groupId?: string;
    hospitalId?: string;
    isActive?: boolean;
    specialityId?: string;
  },
  token: string
): Promise<any> => {
  const config = {
    headers: {
      Authorization: `Token ${token}`,
    },
  };
  const response = await superAdminAxiosInstance.get(
    `${SUPER_ADMIN_API_URL}${SUPER_ADMIN_API_ENDPOINTS.MEMBERSHIP_MANAGEMENT.FETCH_DEACTIVATE_NETWORKS}?search=${searchquery}`,
    config
  )

  return response.data;
};

const fetchDeletedBusinessAccountList = async (
  {
    searchquery,
    pageNumber,
    alphabet,
    groupId,
    hospitalId,
    isActive,
    specialityId,
  }: {
    searchquery: string;
    pageNumber: number;
    alphabet?: string;
    groupId?: string;
    hospitalId?: string;
    isActive?: boolean;
    specialityId?: string;
  },
  token: string
): Promise<any> => {
  const config = {
    headers: {
      Authorization: `Token ${token}`,
    },
  };
  const response = await superAdminAxiosInstance.get(
    `${SUPER_ADMIN_API_URL}${SUPER_ADMIN_API_ENDPOINTS.MEMBERSHIP_MANAGEMENT.FETCH_BUSINESS_ACCOUNTS}?is_active=false`,
    config
  )
  return response.data;
};

const MembersService = {
  fetchNonMembersListData,
  fetchDynamicNetworksList,
  fetchViewDynamicNetworksList,
  fetchMembersListData,
  validateLogin,
  fetchDeletedMembersListData,
  filterMembers,
  deleteMembers,
  fetchLocations,
  fetchSites,
  fetchDeactivatedNetworksList,
  fetchViewNetworksList,
  deactivateMembers,
  activateMembers,
  fetchSAPDynamicNetworksList,
  fetchSAPDeactivatedNetworksList,
  fetchSystemMetricsList,
  fetchDBMetricsList,
  fetchBusinessAccountList,
  updateBusinessAccountList,
  deleteBusinessAccountList,
  fetchDeletedBusinessAccountList,
  deleteBusinessAccount,
  makePayment,
  updateBusinessAccountDetails,
  fetchNotesListData,
  saveNotes,
  editNotes,
  deleteNotes

};

export default MembersService;
